import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const auroraClient = createApiClient(
  actions["exd-storyteller-ai/aurora"],
);

export const putAuroraVideo = async (id, options = {}) => {
  const response = await auroraClient.put(
    `/${encodeURIComponent(id)}`,
    {},
    options,
  );

  if (!response.ok) {
    console.error("Failed to notify Aurora", response);
  }

  return response.data;
};
